var page_url = window.top.location.href;
var user_id = $.cookie('web_visitor_id');
var pass_to_self_serve = false;
var self_serve_link = "";
var page_url = window.location.href;
var device = 'desktop';
var browser = navigator.userAgent;
var source = document.referrer;
var ip_address = "0.0.0.0";
var version = $("#page-version").val()

if  (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    device = 'mobile';
}

$(document).ready(function(){
    setup_tracking();
    register_email_trim();
    register_submit_form();
    register_submit_interest_form();
    register_submit_schedule_demo();
    register_oninput_onchange();
});

function setup_tracking() {
    if (user_id == undefined) {
        ip_address = $("#ip-address").val();
        var screenSize = window.innerWidth+','+window.innerHeight;
        var cookieEnabled = "cookieStatus_"+navigator.cookieEnabled;
        var pricing_layout = "0";
        var data = {
            'webpage':page_url,
            'other_info':JSON.stringify(
                {
                    'ip_address':ip_address,
                    'source':source,
                    'device':device,
                    'browser':browser,
                    'screen_size':screenSize,
                    'mp_layout_selection':'',
                    'cookie_enabled':cookieEnabled,
                    'pricing_layout':pricing_layout,
                    'version': "pricing_" + version,
                })
        };
        var url = "/marketing/website_track/gen_visitor_id/";
        $.post(url, data, function(response){
            //console.log(response);
            //console.log(cookie_domain);
            user_id = response.visitor_id;
            $.cookie('web_visitor_id', user_id, {domain: cookie_domain, expires:365})
        });
    } else {
        var data = {
            'user_id':user_id,
            'webpage':page_url,
            'action':'visit',
            'other_info':JSON.stringify(
                {
                    'ip_address':ip_address,
                    'source':source,
                    'device':device,
                    'browser':browser,
                    'screen_size':screenSize,
                    'mp_layout_selection':'',
                    'cookie_enabled':cookieEnabled,
                    'pricing_layout':pricing_layout,
                    'version': "pricing_" + version,
                })
        };
        var url = "/marketing/website_track/track_action/";
        $.post(url, data, function(response){
            //console.log(response);
        });
    }
}

function register_email_trim() {
    $("#email").change(function() {
        var trimmed = $("#email").val().replace(/ /g, '');
        $("#email").val(trimmed);
    });
}

function register_oninput_onchange() {
    $(":input").change(function() {
        //console.log("track input");
        track_input();
    });
}

function register_submit_form() {
    $("form").submit(function(e){
        e.preventDefault();
        e.stopPropagation();
    });
    $.validate({
        form: "#price-quote-form",
        modules: "location",
        onSuccess: function() { submit_price_quote(); }
    });
}

function submit_tracking() {
    var form_type = $("#form_type").val();
    var email = $("#email").val();
    var phone = $("#phone").val();
    var name = $("#name").val();
    var event_name = $("#event_name").val();
    var event_duration = $("#event_duration").val();
    var heard_of_whova = '';
    var event_size = $("#event_size").val();
    var event_type = $("#event_type").val();
    var page_source = $.cookie("email_touch_source");
    if (page_source != "email_touch") {
        page_source = "";
    }
    var ip_address = $("#ip-address").val();
    var pricing_layout = $.cookie('pricing_page_layout');
    // fall back to the ID from this page load when the browser did not keep the cookie
    var web_visitor_id = $.cookie('web_visitor_id') || user_id;
    var webpage = window.top.location.href;
    var device = "desktop";
    var is_mobile = $("#is-mobile").val();
    if (is_mobile == "yes") {
        device = "mobile";
    }
    var browser = window.top.navigator.userAgent;
    var source = window.top.document.referrer;
    var request_target = "";
    var data = {
        'user_id':web_visitor_id,
        'webpage':webpage,
        'action':'fill',
        'other_info':JSON.stringify({
            'email':email,
            'ip_address':ip_address,
            'heard_of_us':heard_of_whova,
            'source':source,
            'name':name,
            'phone_num':phone,
            'event_name':event_name,
            'event_type':event_type,
            'num_attendees':event_size,
            'event_duration':event_duration,
            'email_touch':page_source,
            'device':device,
            'browser':browser,
            'request_target':request_target,
            'request_type':form_type,
            'pricing_layout':pricing_layout,
            'version': "pricing_" + version,
        })
    };
    var url = "/marketing/website_track/track_action/";
    $.post(url, data, function(response){});
    //ga('send', 'event', 'PriceQuoteSubmit', 'Submit', email+'_'+form_type);
    try{
        gtag('event', 'Submit', {'event_category': 'PriceQuoteSubmit', 'event_label': email+'_'+form_type});
    } catch (error){
        console.error(error)
    }
}

var email = "";
var name = "";
var phone = "";
var event_name = "";
var event_type = "";
var event_size = "";
var events_per_year = "";
var form_type = "";

function submit_price_quote() {
    var allow_schedule_demo = $("#allow-schedule-demo").val();
    form_type = $("#form_type").val();
    var is_mobile = $("#is-mobile").val();
    var need_consent = $("#need_consent").val();
    email = $("#email").val();
    phone = $("#phone").val();
    name = $("#name").val();
    event_name = $("#event_name").val();
    event_type = $("#event_type").val();
    event_size = $("#event_size").val();
    events_per_year = $("#events_per_year").val();
    var event_duration = $("#event_duration").val();
    var heard_of_whova = '';
    var page_source = $.cookie("email_touch_source");
    // fall back to the ID from this page load when the browser did not keep the cookie
    var web_visitor_id = $.cookie('web_visitor_id') || user_id;
    var ip_address = $("#ip-address").val();
    if (page_source != "email_touch") {
        page_source = "";
    }
    var data = {
        "web_visitor_id": web_visitor_id,
        "ip_address": ip_address,
        "email": email,
        "name": name,
        "phone": phone,
        "event_name": event_name,
        "event_duration": event_duration,
        "heard_of_whova": heard_of_whova,
        "event_type": event_type,
        "event_size": event_size,
        "events_per_year": events_per_year,
        "page_source": page_source,
        "form_type": form_type,
    }
    if (form_type == "request_info") {
        data["question"] = $("#question").val();
    }
    if (need_consent == "yes") {
        data["terms_privacy_consent"] = $("#terms_privacy_consent").val();
    }

    $.post("/apps/price_quote/submit/", data, function(response) {
        submit_tracking();
        $("#price-quote-form-div").hide();

        if (allow_schedule_demo == "yes") {
            var demo_slots = response.demo_slots;
            var has_slots = initial_demo_slots(demo_slots);
            var next_page = response.next_page;
            if (has_slots == true) {
                $("#thanks-page").attr("href", next_page);
                $("#schedule-demo-form-div").show();
            } else {
                window.top.location.href = next_page;
            }
        } else {
            var next_page = response.next_page;
            window.top.location.href = next_page;
        }
    });
}

function track_input() {
    var form_type = $("#form_type").val();
    var ip_address = $("#ip-address").val();
    // fall back to the ID from this page load when the browser did not keep the cookie
    var web_visitor_id = $.cookie('web_visitor_id') || user_id;
    var webpage = window.top.location.href;
    var device = "desktop";
    var is_mobile = $("#is-mobile").val();
    if (is_mobile == "yes") {
        device = "mobile";
    }
    var browser = window.top.navigator.userAgent;
    var source = window.top.document.referrer;
    var email = $("#email").val();
    var phone = $("#phone").val();
    var name = $("#name").val();
    var event_name = $("#event_name").val();
    var event_type = $("#event_type").val();
    var event_size = $("#event_size").val();
    var events_per_year = $("#events_per_year").val();
    var event_duration = $("#event_duration").val();
    var heard_of_whova = '';
    var data = {
        'user_id':web_visitor_id,
        'webpage':webpage,
        'action':'input',
        'other_info':JSON.stringify({
            'ip_address':ip_address,
            'source': source,
            'device':device,
            'browser':browser,
            'request_type':form_type,
            "email": email,
            "name": name,
            "phone": phone,
            "event_name": event_name,
            "event_duration": event_duration,
            "heard_of_whova": heard_of_whova,
            "event_type": event_type,
            "event_size": event_size,
            "events_per_year": events_per_year,
            'version': "pricing_" + version,
        })
    };
    var url = "/marketing/website_track/track_action/";
    $.post(url, data, function(response){});
}

function register_submit_interest_form() {
    $("form").submit(function(e){
        e.preventDefault();
        e.stopPropagation();
    });
    $.validate({
        form: "#interest-form",
        modules: "location",
        onSuccess: function() { submit_interest(); }
    });
}

function submit_interest() {
    var allow_schedule_demo = $("#allow-schedule-demo").val();
    var interests = $("#interest-form input:checkbox:checked").map(function() { return $(this).val();}).get();
    //console.log("interests are");
    //console.log(interests);
    var data = {
        "email": email,
        "name": name,
        "phone": phone,
        "event_name": event_name,
        "interest": interests, 
    };
    //console.log("submit interest");
    //console.log(data);
    $.post("/apps/customer_interest/submit/", data, function(response) {
        if (pass_to_self_serve == "yes") {
            window.top.location.href = self_serve_link;
        } else {
            if (allow_schedule_demo == "yes") {
                var demo_slots = response.demo_slots;
                var has_slots = initial_demo_slots(demo_slots);
                var next_page = response.next_page;
                if (has_slots == true) {
                    $("#thanks-page").attr("href", next_page);
                    $("#customer-interest-form-div").hide();
                    $("#schedule-demo-form-div").show();
                } else {
                    window.top.location.href = next_page;
                }
            } else {
                var next_page = response.next_page;
                window.top.location.href = next_page;
            }
        }
    });
}

var local_dates = [];
var local_date_times = {};
var local_slots = [];

function initial_demo_slots(demo_slots) {
    var slots = demo_slots.split(";");
    var i;

    local_dates = [];
    local_slots = [];
    local_date_times = {};

    for (i = 0; i < slots.length; i++) {
        var local_slot = new Date(slots[i]);
        local_slots.push({"server": slots[i], "client": local_slot});
    }

    for (i = 0; i < local_slots.length; i++) {
        var local_slot_str = local_slots[i]["client"].toString();
        var local_date = local_slot_str.substring(0, 15);
        var local_time = local_slot_str.substring(16, 24);
        var local_hour = parseInt(local_time.substring(0, 2));
        if (local_hour < 7 || local_hour > 17) {
            // client local time is either too early or too late
            continue;
        }
        if (local_date in local_date_times) {
            local_date_times[local_date].push({"server": local_slots[i]["server"], "client": local_time});
        } else {
            local_dates.push(local_date);
            local_date_times[local_date] = [{"server": local_slots[i]["server"], "client": local_time}];
        }
    }
    if (local_dates.length == 0) {
        //console.log("no demo slots available");
        return false;
    }

    for (i = 0; i < local_dates.length; i++) {
        //console.log(local_dates[i]);
        //console.log(local_date_times[local_dates[i]]);
        continue;
    }
    var demo_date = document.getElementById("schedule-demo-date");
    for (i = 0; i < local_dates.length; i++) {
        var option = document.createElement("option");
        option.text = local_dates[i];
        option.value = local_dates[i];
        demo_date.add(option);
    }
    on_demo_date_change();
    return true;
}

function on_demo_date_change() {
    var selected_date = document.getElementById("schedule-demo-date").value;
    var demo_times = document.getElementById("schedule-demo-time");
    var i, total_options = demo_times.length;
    for (i = 0; i < total_options; i++) {
        demo_times.remove(0);
    }
    for (i = 0; i < local_date_times[selected_date].length; i++) {
        var option = document.createElement("option");
        option.text = local_date_times[selected_date][i]["client"];
        option.value = local_date_times[selected_date][i]["server"];
        demo_times.add(option);
    }
}
window.on_demo_date_change = on_demo_date_change;

function register_submit_schedule_demo() {
    $("form").submit(function(e){
        e.preventDefault();
        e.stopPropagation();
    });
    $.validate({
        form: "#schedule-demo-form",
        modules: "location",
        onSuccess: function() { submit_schedule_demo(); }
    });
}

function submit_schedule_demo() {
    var demo_time = $("#schedule-demo-time").val();
    var local_time = new Date(demo_time).toString();
    var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var question = $("#question").val();
    var data = {
        "event_name": event_name,
        "email": email,
        "name": name,
        "phone": phone,
        "demo_time": demo_time,
        "client_time": local_time,
        "question": question,
        "event_type": event_type,
        "event_size": event_size,
        "events_per_year": events_per_year,
        "demo_source": form_type,
        "timezone": timezone,
    };
    $(".has-spinner").toggleClass("active");
    var submitButton = $(".btn.submit-demo");
    submitButton.prop("disabled", true);
    $.post("/apps/schedule_demo/submit/", data, function(response){
        var next_page = response.next_page;
        window.top.location.href = next_page;
    });
    //ga('send', 'event', 'DemoScheduleSubmit', 'Submit', email);
    try{
        gtag('event', 'Submit', {'event_category': 'DemoScheduleSubmit', 'event_label': email});   
    } catch (error){
        console.error(error)
    }
}

function sendClickTracking(other_info_dict){
    // fall back to the ID from this page load when the browser did not keep the cookie
    var web_visitor_id = $.cookie('web_visitor_id') || user_id;
    if (web_visitor_id == undefined){
        return;
    }
    var page_url = window.location.href;
    var url = '/marketing/website_track/track_action/';
    other_info_dict['ip_address'] = $("#ip-address").val();;
    other_info_dict['browser'] = browser;
    other_info_dict['device'] = device;
    other_info_dict['source'] = source;
    var data = {'user_id':web_visitor_id,'webpage':page_url,'action':'user_click','other_info':JSON.stringify(other_info_dict)};
    jQuery.post(url, data, function(response){
        console.log(response);
    });
}

jQuery(document).ready(function(){
    jQuery(".whova-navbar .desktop-nav a").click(function(){
        if ($(this).attr("href") != "#"){
            var data;
            if (jQuery(this).attr('class') === "navbar-price-quote-btn"){
                data = {'clicked_btn':'pricing_top_menu_highlight_price_quote'};
            }else{
                data = {'clicked_btn':'pricing_top_menu_'+jQuery(this).attr('href')};
            }
        } else {
            var text = $(this).text();
            if ($(this).parent().hasClass('open')) {
                // If it has open class, it means it was clicked to close
                text = text + "_closed"
            } else {
                text = text + "_open"
            }
            data = {'anchor_text': text}
        }
        sendClickTracking(data);
    });
});

jQuery(document).ready(function(){
    jQuery(".whova-navbar .mobile-nav a").click(function(){
        if ($(this).attr("href") != "#"){
            var data = {'clicked_btn':'pricing_mobile_menu_'+$(this).attr('href')};
            sendClickTracking(data);
        }
    });
});

jQuery(document).ready(function(){
    jQuery(".stripnav a").click(function(){
        var data = {'clicked_btn':'pricing_second_menu_'+jQuery(this).attr('href')};
        sendClickTracking(data);
    });
});


// FIREFOX BEHAVIOUR FIX
// (MOBILE)
(function () {
    'use strict';

    // Firefox for iOS only.
    if (!/FxiOS\/[\d.]+/.test(navigator.userAgent)) {
        return;
    }

    const bannerSelector = '#cmplz-cookiebanner-container';

    const keyboardInputSelector = [
        'textarea',
        'input'
    ].join(', ');

    function updateBanner() {
        const banner = document.querySelector(bannerSelector);

        if (!banner) {
            return;
        }

        const inputFocused =
            document.activeElement &&
            document.activeElement.matches(keyboardInputSelector);

        banner.classList.toggle(
            'cmplz-firefox-ios-keyboard',
            !!inputFocused
        );
    }

    document.addEventListener('focusin', updateBanner);

    document.addEventListener('focusout', function () {
        setTimeout(updateBanner, 100);
    });

    updateBanner();
})();